import { InterviewQuestionType } from '@components/pass/interview/start/context/interviewContext';

export class InterviewPracticeCreateRq {
  pooledQuestionSns: number[];

  constructor(selectedQuestionList: InterviewQuestionType[]) {
    // Set을 사용하여 중복을 제거한 후 배열로 변환
    this.pooledQuestionSns = Array.from(new Set(selectedQuestionList.map((question) => question.sn)));
  }
}
